import { Helper, HelperPayload } from '@interfaces/api/helper'
import { axiosPut } from '@services/api/axios'

export const apiHelperUpdate = async (activityId: number, payload: HelperPayload) =>
  await axiosPut<HelperPayload, Helper>(`/external-app-plugin/activities/${activityId}/helper`, payload)
